module.exports = __webpack_public_path__ + "img/01.aaa2fb72.jpg";